export const transformItem = (node: any) => typeof node === 'string' ? { label: node, value: node } : node
